import { render, staticRenderFns } from "./PayRangeEditorIcon.vue?vue&type=template&id=d6044b80"
import script from "./PayRangeEditorIcon.vue?vue&type=script&lang=js"
export * from "./PayRangeEditorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports